import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgCalendarModule } from '@principle-theorem/ng-calendar';
import { NgEditorModule } from '@principle-theorem/ng-editor';
import { NgFeatureFlagsModule } from '@principle-theorem/ng-feature-flags';
import { NgInteractionsModule } from '@principle-theorem/ng-interactions';
import { NgIntercomComponentsModule } from '@principle-theorem/ng-intercom';
import { NgLabsModule } from '@principle-theorem/ng-labs';
import { MarketingCampaignService } from '@principle-theorem/ng-marketing';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgMediaManagerModule } from '@principle-theorem/ng-media-manager';
import { NgNotificationsModule } from '@principle-theorem/ng-notifications';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { NgTasksModule } from '@principle-theorem/ng-tasks';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CoreModule } from '../core/core.module';
import { ToolbarDropdownComponent } from './account/toolbar-dropdown/toolbar-dropdown.component';
import { AuthComponentsModule } from './auth/auth-components.module';
import { BillingEntityInputComponent } from './billing-entity-input/billing-entity-input.component';
import { CreateBrandComponent } from './create-brand/create-brand.component';
import { ManagementJobsModule } from './management-jobs/management-jobs.module';
import { NotificationTypeFilterComponent } from './notifications/notification-type-filter/notification-type-filter.component';
import { NotificationsSidebarComponent } from './notifications/notifications-sidebar/notifications-sidebar.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { OrganisationActionsComponent } from './organisation-actions/organisation-actions.component';
import { OrganisationWorkspaceSelectorComponent } from './organisation-workspace-selector/organisation-workspace-selector.component';
import { NavbarComponent } from './page-splash/navbar/navbar.component';
import { PageSplashComponent } from './page-splash/page-splash.component';
import { ProviderDetailsInputComponent } from './provider-details-input/provider-details-input.component';
import { RolesModule } from './roles/roles.module';
import { SettingsSidebarComponent } from './settings-sidebar/settings-sidebar.component';
import { SidebarModule } from './sidebar/sidebar.module';
import { SnippetFormComponent } from './snippet/snippet-form/snippet-form.component';
import { SearchPlaceholderComponent } from './toolbar/search-placeholder/search-placeholder.component';
import { SearchComponent } from './toolbar/search/search.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { UsersModule } from './users/users.module';

@NgModule({
  declarations: [
    OrganisationWorkspaceSelectorComponent,
    NotificationsComponent,
    NotificationsSidebarComponent,
    NotificationTypeFilterComponent,
    SnippetFormComponent,
    SettingsSidebarComponent,
    ToolbarDropdownComponent,
    ToolbarComponent,
    SearchComponent,
    SearchPlaceholderComponent,
    ProviderDetailsInputComponent,
    OrganisationActionsComponent,
    CreateBrandComponent,
  ],
  imports: [
    CommonModule,
    NgPrincipleSharedModule,
    NgMaterialModule,
    NgSharedModule,
    ReactiveFormsModule,
    NgEditorModule,
    UsersModule,
    RolesModule,
    NgNotificationsModule,
    CoreModule,
    AuthComponentsModule,
    NgInteractionsModule,
    NgMediaManagerModule,
    SidebarModule,
    NgFeatureFlagsModule,
    NgTasksModule,
    NgLabsModule,
    NgCalendarModule,
    ManagementJobsModule,
    NgIntercomComponentsModule,
    NgxSkeletonLoaderModule,
    NavbarComponent,
    PageSplashComponent,
    BillingEntityInputComponent,
  ],
  exports: [
    AuthComponentsModule,
    OrganisationWorkspaceSelectorComponent,
    UsersModule,
    RolesModule,
    NotificationsComponent,
    NotificationsSidebarComponent,
    PageSplashComponent,
    SettingsSidebarComponent,
    SidebarModule,
    ToolbarDropdownComponent,
    ToolbarComponent,
    SearchComponent,
    ProviderDetailsInputComponent,
    BillingEntityInputComponent,
    ManagementJobsModule,
    OrganisationActionsComponent,
    CreateBrandComponent,
  ],
  providers: [MarketingCampaignService],
})
export class ComponentsModule {}
